var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStarGreenHalfQuarter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1201 19.3754L25.6574 28.4433C25.7637 29.0672 25.3493 29.6589 24.7329 29.7664C24.4885 29.8094 24.2335 29.77 24.0139 29.6517L15.9697 25.3705L7.92561 29.6517C7.7386 29.7516 7.52767 29.7965 7.31672 29.7813C7.10578 29.7661 6.90328 29.6913 6.73217 29.5655C6.56106 29.4397 6.42819 29.2679 6.34864 29.0696C6.26908 28.8712 6.24603 28.6543 6.28208 28.4433L7.81935 19.3754L1.3125 12.9537C1.09703 12.7411 0.97376 12.4506 0.969774 12.146C0.965789 11.8414 1.08141 11.5477 1.29124 11.3294C1.46481 11.1501 1.6915 11.0318 1.93945 10.9959L10.9329 9.67287L14.9532 1.42246C15.233 0.855945 15.9131 0.622882 16.4727 0.902557C16.6959 1.01371 16.8765 1.19657 16.9863 1.42246L21.0066 9.67287L30 10.9959C30.6199 11.0892 31.0521 11.67 30.9564 12.2975C30.921 12.5485 30.8041 12.778 30.627 12.9537L24.1201 19.3754ZM13.1572 24.723L15.9697 23.2262L23.5549 27.2631L22.1054 18.713L28.2433 12.6554L19.7612 11.4076L15.9697 3.62674L13.1572 9.39867L11.9697 11.525L9.96968 12.146V18.713V26.5L13.1572 24.723Z",
    fill: "#7CAD53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarGreenHalfQuarter);
export default __webpack_public_path__ + "static/media/icon_star_green_half_quarter.0e6c5c467dc39890cfdd255d30670dcf.svg";
export { ForwardRef as ReactComponent };